import { LimitInformation } from '@varo/graphql-schema-types';
import { NativeStackHeaderProps, Stack } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import theme from 'shared/styles/theme';

export interface WalletPayLimitInfoProps {
  title: string;
  dailyLimitInformation: LimitInformation | null;
  monthlyLimitInformation: LimitInformation | null;
  disclaimer: string | null;
}

const WalletPayLimitInfo = ({
  title,
  dailyLimitInformation,
  monthlyLimitInformation,
  disclaimer,
}: WalletPayLimitInfoProps) => (
  <>
    <Stack.Screen
      options={{
        headerShown: true,
        title,
        headerBackVisible: true,
        header: (props: NativeStackHeaderProps) => (
          <ExpoNavigationBar {...props} primaryOnPress={navigateBack} />
        ),
      }}
    />
    <View style={styles.container}>
      {dailyLimitInformation ? (
        <>
          <BodyBaseBoldText style={styles.title} numberOfLines={0}>
            {dailyLimitInformation.title}
          </BodyBaseBoldText>
          <BodyBaseText style={styles.contentPadding} numberOfLines={0}>
            {dailyLimitInformation.message1}
          </BodyBaseText>
          <BodyBaseText numberOfLines={0}>
            {dailyLimitInformation.message2}
          </BodyBaseText>
        </>
      ) : null}
      {monthlyLimitInformation ? (
        <View style={styles.sectionPadding}>
          <BodyBaseBoldText numberOfLines={0}>
            {monthlyLimitInformation.title}
          </BodyBaseBoldText>
          <BodyBaseText style={styles.contentPadding} numberOfLines={0}>
            {monthlyLimitInformation.message1}
          </BodyBaseText>
          <BodyBaseText numberOfLines={0}>
            {monthlyLimitInformation.message2}
          </BodyBaseText>
        </View>
      ) : null}
      {disclaimer ? (
        <View style={styles.disclaimerSection}>
          <BodyBaseText numberOfLines={0}>{disclaimer}</BodyBaseText>
        </View>
      ) : null}
    </View>
  </>
);

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    paddingHorizontal: theme.spacing.m,
  },
  contentPadding: {
    paddingVertical: theme.spacing.s,
  },
  sectionPadding: {
    paddingTop: theme.spacing.m,
  },
  disclaimerSection: {
    marginTop: theme.spacing.l,
  },
  title: {
    marginTop: theme.spacing.m,
  },
});

export default WalletPayLimitInfo;
